export default "<div class=\"loaderMask\"><span class=\"spinner\"></span></div>\n";